// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610061436/js/" + chunkId + "." + {"44":"bcef7e75","225":"5733457a","481":"bf4bbc43","486":"8ccd55b8","770":"0205fe41"}[chunkId] + ".0.7474299108770973.chunk.js";
};